import { apiInstanceFetch } from "../../../util/api";
import axios from "axios";
import * as ActionType from "./serviceCategory.type";
import { setToast } from "../../../util/toast";

export const getServiceCategories = () => (dispatch) => {
  apiInstanceFetch
    .get(`serviceCategory/all`)
    .then((res) => {
      dispatch({ type: ActionType.GET_SERVICE_CATEGORIES, payload: res.data || [] });
    })
    .catch((error) => console.error(error));
};

export const createServiceCategory = (payload) => (dispatch) => {
  axios
    .post(`serviceCategory/create`, payload)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.CREATE_SERVICE_CATEGORY, payload: res.data.data });
        setToast("success", "Category created");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((e) => setToast("error", e.message || "request failed"));
};

export const updateServiceCategory = (id, payload) => (dispatch) => {
  axios
    .patch(`serviceCategory/update?id=${id}`, payload)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.UPDATE_SERVICE_CATEGORY, payload: res.data.data });
        setToast("success", "Category updated");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((e) => setToast("error", e.message || "request failed"));
};

export const deleteServiceCategory = (id) => (dispatch) => {
  axios
    .delete(`serviceCategory/delete?id=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.DELETE_SERVICE_CATEGORY, payload: id });
        setToast("success", "Category deleted");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((e) => setToast("error", e.message || "request failed"));
};
